import { CartItem } from '@pedix-workspace/utils';

/**
 * Ids de las entidades que sostienen stock en un carrito: productos, presentaciones y option-items (compartidos y embebidos)
 * (ausencia = infinito).
 */
export function getCartProductStockIds(cartItems: CartItem[]): string[] {
  const stockIds: Set<string> = new Set();

  cartItems.forEach(cartItem => {
    if (cartItem.selectedPresentation) {
      cartItem.selectedPresentation.items.forEach(presentation => {
        stockIds.add(presentation.id);
      });
    } else {
      stockIds.add(cartItem.product.id);
    }

    if (cartItem.selectedOptions) {
      cartItem.selectedOptions.forEach(selectedOption => {
        selectedOption.items.forEach(item => {
          stockIds.add(item.id);
        });
      });
    }
  });

  return Array.from(stockIds);
}
